export const myCompare = (a, b) => a.label && a.label.toString().toLowerCase() > b.label && b.label.toString().toLowerCase() ? 1 : -1;
export const myCompareFilter = (a, b) => (a.name > b.name ? 1 : -1);
export const myCompareLecturer = (a, b) => (a.Firstname + " " + a.Lastname > b.Firstname + " " + b.Lastname ? 1 : -1);
export const myTypeCompare = (a, b) => (a.value > b.value ? 1 : -1);
export const myCommonCompare = (a, b,data) => (a[data].toLowerCase() > b[data].toLowerCase() ? 1 : -1);


